/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OpenAPIv3Evaluation,
  OpenAPIv3Evaluation$inboundSchema,
} from "./openapiv3evaluation.js";

export type GetDeploymentEvaluationResult = {
  /**
   * The ID of the deployment it is compared with. Absent for the first deployment in a project.
   */
  baseDeploymentId?: string | undefined;
  /**
   * The ID of the evaluated deployment.
   */
  deploymentId: string;
  /**
   * One evaluation per OpenAPI source that was added, changed or removed.
   */
  documents: Array<OpenAPIv3Evaluation>;
};

/** @internal */
export const GetDeploymentEvaluationResult$inboundSchema: z.ZodMiniType<
  GetDeploymentEvaluationResult,
  unknown
> = z.pipe(
  z.object({
    base_deployment_id: z.optional(z.string()),
    deployment_id: z.string(),
    documents: z.array(OpenAPIv3Evaluation$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "base_deployment_id": "baseDeploymentId",
      "deployment_id": "deploymentId",
    });
  }),
);

export function getDeploymentEvaluationResultFromJSON(
  jsonString: string,
): SafeParseResult<GetDeploymentEvaluationResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetDeploymentEvaluationResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetDeploymentEvaluationResult' from JSON`,
  );
}
